import { Box, Grid } from "@material-ui/core"
import React from "react"
import RenderInput from "./RenderInput"

export default function ContactForm(props) {
  const {
    formField: { firstName, lastName, email, phone, societyName },
    inputClassName,
  } = props

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <RenderInput name={firstName.name} placeholder='Prénom*' autoFocus className={inputClassName} label='' />
        </Grid>
        <Grid item xs={6}>
          <RenderInput name={lastName.name} placeholder='Nom*' className={inputClassName} label='' />
        </Grid>
        <Grid item xs={6}>
          <RenderInput name={email.name} placeholder='Adresse mail*' className={inputClassName} label='' />
        </Grid>
        <Grid item xs={6}>
          <RenderInput name={phone.name} placeholder='Téléphone*' className={inputClassName} label='' />
        </Grid>
        <Grid item xs={12}>
          <RenderInput name={societyName.name} placeholder='Entreprise/club*' className={inputClassName} label='' />
        </Grid>
      </Grid>
    </Box>
  )
}

